import {computed, inject} from 'vue';

/**
 * Resolves a field's tooltip key to its rendered HTML.
 *
 * The map is provided by App.vue from the `descriptions` block of the form config,
 * which PHP fills from tx_lfmpublications_domain_model_descriptions. Keys are the
 * Vue form keys defined in FieldDescriptionService::GROUPS.
 *
 * @param {import('vue').Ref<string>|{value: string}} tooltipKey
 */
export function useFieldTooltip(tooltipKey) {
    const descriptions = inject('descriptions', {});

    return computed(() => {
        const key = tooltipKey.value;
        return (key && descriptions[key]) || '';
    });
}
